import {Component, OnInit, Input} from '@angular/core';
import {Product} from '../../../models/product.model';
import {CartService} from '../../api/services/cart.service';
import {ArtistService, ScrollService, ScrollParams, PlaylistService} from '../../api/';
import * as _ from 'lodash';
import {BlockUI, NgBlockUI} from 'ng-block-ui';
import {MdDialog, MdDialogRef} from '@angular/material';
import {ConfirmDialogComponent} from '../../';

@Component({
    selector: 'add-to-cart',
    templateUrl: './add-to-cart.component.html',
    styleUrls: ['./add-to-cart.component.css']
})
export class AddToCartComponent implements OnInit {
    @Input() product: Product;
    @Input() artist: any;
    @Input() playlist: any;
    @Input() disabled: boolean;
    dialogRef: MdDialogRef<ConfirmDialogComponent>;
    // artist: any;
    private isAlreadyInPlaylist = false;
    private message: string = '';
    private scrollParams = new ScrollParams();
    detailViewActive: boolean;
    private songs: any = new Array<any>();
    @BlockUI() blockUI: NgBlockUI;
    public onlineOffline1: boolean = navigator.onLine;

    constructor(public dialog: MdDialog, private playlistService: PlaylistService, private cartService: CartService, private scrollService: ScrollService, private artistService: ArtistService) {
        window.addEventListener('online', () => {this.onlineOffline1 = true; });
        window.addEventListener('offline', () => {this.onlineOffline1 = false});
    }

    ngOnInit() {
        if (this.artist) {
            this.message = "Are you sure you want to add the entire artist songs to your shopping cart?";
        } else if (this.playlist) {
            this.message = "Are you sure you want to add the entire playlist to your shopping cart?";
        }
    }


    getTracks() {
        if (this.playlist) {
            this.scrollService.toggleProgressBar(true);
            this.blockUI.start('Loading, please wait...');
            if(this.onlineOffline1){
            this.playlistService.getPlaylistSongs(this.playlist.id).subscribe((songs) => {
                if(songs){
                songs.forEach((song) => {
                    song.playedFrom = 'playlist';
                    this.songs.push(song);
                });
                }
                this.songs = _.uniqBy(this.songs, 'id');
                for (let i = 0; i < this.songs.length; i++) {

                    this.cartService.addItem(this.songs[i], i);
                }
                this.blockUI.stop();
                this.scrollService.toggleProgressBar(false);
            },
            (error) => {
                console.log(error);
            });
            }else {
                this.blockUI.stop();
                this.scrollService.toggleProgressBar(false);
            }
        }

        if (this.artist) {
            this.scrollService.toggleProgressBar(true);
            if(this.onlineOffline1){
                this.artistService.getArtistTracks(this.scrollParams.page, this.artist.id).subscribe((artistSongs) => {
                artistSongs.forEach((song) => {
                    song.playedFrom = 'artist';

                    this.songs.push(song);
                });
                this.songs = _.uniqBy(this.songs, 'id');

                for (let i = 0; i < this.songs.length; i++) {

                    this.cartService.addItem(this.songs[i], i);
                }
                this.blockUI.stop();

                this.scrollService.toggleProgressBar(false);
            },
            (error) => {
                console.log(error);
            });
                }else {
                this.blockUI.stop();
                this.scrollService.toggleProgressBar(false);
            }
        }
    }

    onProductClick() {
        this.detailViewActive = !this.detailViewActive;
    }


    onAddToCart(event) {

        if (this.artist || this.playlist) {
            event.stopPropagation();
            event.preventDefault();

            this.dialogRef = this.dialog.open(ConfirmDialogComponent, {
                disableClose: false,
            });
            this.dialogRef.componentInstance.message = this.message;
            this.dialogRef.afterClosed().subscribe(result => {
                if (result && result === true) {

                    this.getTracks();
                    return false;

                }
            });

        } else {
            this.blockUI.start('Loading, please wait...');
            event.stopPropagation();
            event.preventDefault();
            if(this.product){
                if(this.onlineOffline1){
                this.cartService.addItem(this.product);
              }
            }
            this.blockUI.stop();
            return false;
        }
    }
}




// WEBPACK FOOTER //
// ./src/app/shared/add-to-cart/add-to-cart.component.ts